import WalkCommand from '../commands/WalkCommand';
import JumpCommand from '../commands/JumpCommand';
import TurnCommand from '../commands/TurnCommand';
import RepeatCommand from '../commands/RepeatCommand';
import MorphCommand from '../commands/MorphCommand';
import common from '../common';

export default class VariableSelector extends PIXI.Container {
	constructor(command, options = null) {
		super();

		this.signals = {};
		this.signals.select = new P3.utils.MiniSignal();
		this.signals.destroy = new P3.utils.MiniSignal();
		this.command = command;
		this.options = command.options || options;
		// 'top' or 'slide'		 determines how to tween
		this.type = 'top';

		this.leftTurnButton = null;
		this.rightTurnButton = null;

		this.init();
	}

	init() {
		if (typeof this.options[0] === 'number') {
			if (this.command.variableActive) {
				this.plotNumberOptions();
			}

			this.type = 'slide';
		} else if (this.command instanceof TurnCommand) {
			this.plotTurnOptions();

			this.type = 'slide';
		} else if (this.command instanceof MorphCommand) {
			this.plotAlienOptions();

			this.type = 'slide';
		}

		this.on('pointerupoutside', () => {
			this.destroy();
		});

		this.interactive = true;
	}

	update() {
		// this.tweens.update();
	}

	destroy() {
		this.signals.destroy.dispatch();
		super.destroy();
	}

	plotNumberOptions() {
		const minusButton = new PIXI.Sprite(P3.assets.texture('ui_icon_subtract_out'));

		minusButton.position.set(5, 10);
		minusButton.interactive = true;
		minusButton.buttonMode = true;
		minusButton.val = {type: 'number', value: -1};

		minusButton.on('pointertap', () => {
			P3.audio.playSound('sfx_btn_press_00');

			this.onOptionClick(minusButton.val);
		});

		minusButton.on('pointerover', () => {
			minusButton.texture = P3.assets.texture('ui_icon_subtract_over');
		});

		minusButton.on('pointerout', () => {
			minusButton.texture = P3.assets.texture('ui_icon_subtract_out');
		});

		minusButton.scale.set(1.5);

		this.addChild(minusButton);

		const plusButton = new PIXI.Sprite(P3.assets.texture('ui_icon_add_out'));

		plusButton.position.set(minusButton.x + 75, 10);
		plusButton.interactive = true;
		plusButton.buttonMode = true;
		plusButton.val = {type: 'number', value: 1};

		plusButton.on('pointertap', () => {
			P3.audio.playSound('sfx_btn_press_00');

			this.onOptionClick(plusButton.val);
		});

		plusButton.on('pointerover', () => {
			plusButton.texture = P3.assets.texture('ui_icon_add_over');
		});

		plusButton.on('pointerout', () => {
			plusButton.texture = P3.assets.texture('ui_icon_add_out');
		});

		plusButton.scale.set(1.5);

		this.addChild(plusButton);

		const bg = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_function_options_bg'), 13, 13, 13, 13);

		bg.width = this.width + 10;
		bg.height = common.commandDimensions.height;
		bg.position.set(0, this.y);

		this.addChildAt(bg, 0);
	}

	plotCommandOptions() {
		const commands = [];

		const classes = {WalkCommand, JumpCommand, TurnCommand, MorphCommand, RepeatCommand};

		for (const ability of common.levelSettings.abilities) {
			if (ability === 'variables') {
				continue;
			}

			commands.push(new classes[ability]());
		}

		let totalHeight = 0;

		for (const item in commands) {
			commands[item].position.set(0, totalHeight);

			totalHeight += commands[item].height + 5;

			commands[item].interactive = true;
			commands[item].grabbable = true;

			this.addChild(commands[item]);
		}
	}

	plotTurnOptions() {
		const images = ['left', 'right'];

		for (let i = 0; i < this.options.length; i++) {
			const option = new PIXI.Sprite(P3.assets.texture(`ui_icon_${images[i]}_large`));

			if (i === 0) {
				this.leftTurnButton = option;
			} else if (i === 1) {
				this.rightTurnButton = option;
			}

			option.position.set(i * 60, 0);
			option.interactive = true;
			option.buttonMode = true;
			option.val = {type: 'text', value: this.options[i]};

			option.on('pointertap', () => {
				P3.audio.playSound('sfx_btn_press_00');

				this.onOptionClick(option);
			});

			this.addChild(option);
		}

		const bg = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_function_options_bg'), 13, 13, 13, 13);

		bg.width = this.width + 10;
		bg.height = this.command.height - 1;
		bg.position.set(this.x - 5, this.y - 2);

		this.addChildAt(bg, 0);
	}

	plotAlienOptions() {
		for (let i = 0; i < this.options.length; i++) {
			const tex = `ui_function_char_${this.options[i].toLowerCase()}`;

			const option = new PIXI.Sprite(P3.assets.texture(tex));
			option.position.set(i * 90, 0);
			option.interactive = true;
			option.buttonMode = true;
			option.val = {type: 'text', value: this.options[i]};
			option.on('pointertap', () => {
				P3.audio.playSound('sfx_btn_press_00');
				this.onOptionClick(option);
			});

			this.addChild(option);
		}

		const bg = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_function_options_bg'), 13, 13, 13, 13);
		bg.width = this.width;
		bg.height = this.command.height;
		bg.position.set(0, this.y + 4);
		bg.tint = 0xAAFF00;

		this.addChildAt(bg, 0);
	}

	onOptionClick(option) {
		this.signals.select.dispatch(option);
	}
}
